import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import util from 'util';
import { useToasts } from 'react-toast-notifications';
import { useHistory } from 'react-router-dom';
import { useParams, generatePath } from 'react-router';

const EntryType = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const history = useHistory();
  const { addToast } = useToasts();
  const [entryData, setEntryData] = useState(null);
  const PAGE_SIZE = 5;
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshEntry = useCallback(async () => {
    var reg_params = { site_id: siteId , mall_id: mallId };

    const jwt = localStorage.getItem('jwt');
    const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/entry_type/search/`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data;

    result.sort((a, b) => a.entry_type < b.entry_type ? -1 : 1);
    setEntryData(result);
  }, [siteId, mallId]);

    const questionnaireButtonClick = async (entry_type) => {
    try {
      history.push(`${generatePath(`${props.match.path}questionnaire`, { siteId: siteId, mallId: mallId })}`);
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    }
  }


  const editButtonClick = async (entry_type) => {
    try {
      history.push(`${generatePath(`${props.match.path}entrytype/edit/${entry_type}`, { siteId: siteId, mallId: mallId })}`);
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    }
  }

  const registerClick = () => {
    history.push(`${generatePath(`${props.match.path}entrytype/edit/`, { siteId: siteId, mallId: mallId })}`);
  }

  const updateButton = (data) => {
    // console.log(edit_Flag);
    return (
      <button type="button"
        className={`btn btn-primary text-nowrap`}
        onClick={() => editButtonClick(data.entry_type)}>
        編集
      </button>
    )
  }

  useEffect(() => {
    async function fetchData() {
      await refreshEntry();
    }
    return fetchData();
  }, [refreshEntry]);

  const renderList = () => {
    const filteredData = entryData.filter(data =>
      !searchKeyword || (data.entry_type_name || '').includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3 p-0">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="設問で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center">
                  入力区分
                </td>
                <td className="text-center">
                  設問
                </td>
                <td className="text-center ">
                  短縮名
                </td>
                <td className="text-center">
                  備考
                </td>
                <td className="text-center" width="10%">
                  編集
                </td>
              </tr>
            </thead>
            <tbody>
              {pagedData.map((data, idx) => (
                <tr key={idx}>
                  {/* 入力区分 */}
                  <td className="text-left align-middle">
                    {data.entry_type}
                  </td>
                  {/* 設問 */}
                  <td className="text-left align-middle ">
                    {data.entry_type_name || ""}
                  </td>
                  {/* 短縮名 */}
                  <td className="text-left align-middle">
                    {data.entry_type_short_name || ""}
                  </td>
                  {/* 備考 */}
                  <td className="text-center align-middle">
                    {data.remarks || ""}
                  </td>
                  {/* 編集ボタン */}
                  <td className="text-center align-middle">
                    {updateButton(data)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button className="btn btn-dark mb-5" onClick={registerClick}>新規登録</button>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="row d-none"><div className="col-12">{util.inspect(user)}</div></div>
      {entryData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}

      <button className="btn btn-dark my-5" onClick={questionnaireButtonClick}>アンケート作成</button>
      {entryData !== null && renderList()}

    </div>
  )
}

export default EntryType;
